import { render, staticRenderFns } from "./TipsTab.vue?vue&type=template&id=b18e8d3c&scoped=true&"
import script from "./TipsTab.vue?vue&type=script&lang=js&"
export * from "./TipsTab.vue?vue&type=script&lang=js&"
import style0 from "./TipsTab.vue?vue&type=style&index=0&id=b18e8d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e8d3c",
  null
  
)

export default component.exports